// Customer-facing cart route paths. Shop/category paths live in categoryRoutes.ts; demonstrator portal paths in portalRoutes.ts.

export const CART_PATH = '/cart' as const

// Query flag that sends a shopper back to the cart to run the bonus item step after sign-in (AB#63452).
export const BONUS_SELECT_QUERY_KEY = 'bonusSelect'
export const BONUS_SELECT_QUERY_VALUE = '1'
export const BONUS_RETURN_PATH = `${CART_PATH}?${BONUS_SELECT_QUERY_KEY}=${BONUS_SELECT_QUERY_VALUE}` as const

// Query flag that returns a shopper to the cart with the bonus selection message after checkout rejected the selection (AB#63453).
export const BONUS_ERROR_QUERY_KEY = 'bonusError'
export const BONUS_ERROR_QUERY_VALUE = '1'
